import ExceptionPermissionManage from './ExceptionPermissionManage';

/** @deprecated 예외권한설정으로 이전 — 즐겨찾기·구 URL 호환 */
export default function PermissionExceptionManage() {
  return <ExceptionPermissionManage />;
}
